import { render, staticRenderFns } from "./MyInvest.vue?vue&type=template&id=c8865b54&scoped=true&"
import script from "./MyInvest.vue?vue&type=script&lang=js&"
export * from "./MyInvest.vue?vue&type=script&lang=js&"
import style0 from "./MyInvest.vue?vue&type=style&index=0&id=c8865b54&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8865b54",
  null
  
)

export default component.exports